import { getInstance } from '../../../api/instance';
import {
  CreatePricingConfigPayload,
  PricingConfig,
  UpdatePricingConfigPayload,
} from './types';

/**
 * Pricing-config CRUD for the DS admin MOD contract. Paths are relative to
 * the shared `dsInstance` baseURL (which already carries `/v1`), so
 * `abo/mod/pricing-config` resolves to `/v1/abo/mod/pricing-config`.
 */
export const PRICING_CONFIG_PATH = 'abo/mod/pricing-config';

const instance = getInstance();

export const fetchPricingConfigs = async (): Promise<PricingConfig[]> => {
  const { data } = await instance.get<PricingConfig[]>(PRICING_CONFIG_PATH);
  return data;
};

/** Creating an active config auto-deactivates the previous one for the kind. */
export const createPricingConfig = async (
  payload: CreatePricingConfigPayload,
): Promise<PricingConfig> => {
  const { data } = await instance.post<PricingConfig>(
    PRICING_CONFIG_PATH,
    payload,
  );
  return data;
};

/** `assetKind` is immutable — the backend rejects attempts to change it. */
export const updatePricingConfig = async (
  id: string,
  payload: UpdatePricingConfigPayload,
): Promise<PricingConfig> => {
  const { data } = await instance.patch<PricingConfig>(
    `${PRICING_CONFIG_PATH}/${encodeURIComponent(id)}`,
    payload,
  );
  return data;
};

/** Soft deactivation — the config row is kept for audit. */
export const deactivatePricingConfig = async (
  id: string,
): Promise<PricingConfig> => {
  const { data } = await instance.delete<PricingConfig>(
    `${PRICING_CONFIG_PATH}/${encodeURIComponent(id)}`,
  );
  return data;
};
